import React from 'react';
import cn from 'clsx';
import { Typography } from 'common/components';
import { formatToRub, removeSpecialCharacters } from 'utils/format';
import {
  newProductPrice,
  newProductPriceCredit,
  newProductPriceCurrency,
  newProductPriceWrapper,
  productPrice,
  productPriceCurrency,
  productPriceWrapper,
} from './product-price-styles';

type ProductPriceProps = {
  price: number;
  prefix?: string;
  isNewKitchen?: boolean;
};

export const ProductPrice: React.FC<ProductPriceProps> = ({ price, prefix, isNewKitchen = false }) => (
  <div className={cn({ [newProductPriceWrapper]: isNewKitchen })}>
    <div className={productPriceWrapper} itemScope itemProp="offers" itemType="https://schema.org/Offer">
      {prefix && (
        <>
          <Typography
            adaptive={false}
            as="span"
            className={cn(productPriceCurrency, { [newProductPriceCurrency]: isNewKitchen })}
            variant="m"
            size="body_long">
            {prefix}
          </Typography>{' '}
        </>
      )}
      <Typography
        adaptive={false}
        as="span"
        className={cn(productPrice, { [newProductPrice]: isNewKitchen })}
        itemProp="price"
        content={`${price}.00`}
        variant="h2">
        {removeSpecialCharacters(formatToRub(price))}
      </Typography>{' '}
      <Typography
        adaptive={false}
        as="span"
        className={cn(productPriceCurrency, { [newProductPriceCurrency]: isNewKitchen })}
        content="RUB"
        itemProp="priceCurrency"
        variant="m"
        size="body_long">
        ₽
      </Typography>
      <Typography
        adaptive={false}
        as="span"
        className={cn(productPriceCurrency, { [newProductPriceCurrency]: isNewKitchen })}
        variant="m"
        size="body_long">
        /шт.
      </Typography>
    </div>
    {isNewKitchen && (
      <Typography className={newProductPriceCredit} variant="caption_accent">
        от {formatToRub(Math.floor(price / 10))} ₽/мес
      </Typography>
    )}
  </div>
);
